import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className, y = 32, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, align = "center" }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} gap-4 mb-12 sm:mb-16`}>
      <Reveal className="flex items-center gap-4">
        <span className="h-px w-10 bg-gold/50" />
        <span className="eyebrow">{eyebrow}</span>
        <span className="h-px w-10 bg-gold/50" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-ivory">
          {title}
        </h2>
      </Reveal>
      {sub ? (
        <Reveal delay={0.2}>
          <p className="text-base sm:text-lg font-light text-ivory-dim leading-relaxed max-w-2xl">
            {sub}
          </p>
        </Reveal>
      ) : null}
    </div>
  );
}
